import { LOCAL_STORAGE_VARS } from 'modules/common/constants/enums';

const isAllowedToken = () => {
  return !!localStorage.getItem(LOCAL_STORAGE_VARS.IS_ALLOWED_TOKEN);
};

export default isAllowedToken;
